import { useInfiniteQuery, type UseInfiniteQueryResult } from 'react-query'
import { get } from '@fable/api'
import { RatingComparisonResponse } from '../types'
import { useStats } from 'app/webview/pages/stats_profile/lib/ctx/stats'

export const getCommunityRating = async ({
  userId,
  year,
  pageParam,
}: {
  userId: string
  year: number
  pageParam?: string
}) => {
  let url = `/advanced_stats/reviews_comparison/?user_id=${userId}&year=${year}`

  if (pageParam) url = pageParam

  return await get(url)
}

export const useChartUsery = ({ enabled = false }: { enabled?: boolean }) => {
  const [year, userId] = useStats((s) => [s.year, s.statsUserId])

  const query: UseInfiniteQueryResult<RatingComparisonResponse> =
    useInfiniteQuery(
      ['stats-community-rating', userId, year],
      ({ pageParam }) => getCommunityRating({ userId, year, pageParam }),
      {
        getNextPageParam: (data) => data?.data?.next,
        keepPreviousData: true,
        enabled: !!enabled && !!userId,
        refetchOnWindowFocus: true,
        refetchOnMount: true,
        staleTime: 0,
        cacheTime: 0,
      }
    )

  return query
}
